module.exports = __webpack_public_path__ + "static/media/2_7.333751cf.png";